(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horizontal-slideshow"] && !Shopify.designMode) return;
  try {
    
  function hsInit() {
    document.querySelectorAll('.hs-section').forEach(function (section) {
      hsInitSection(section);
    });
  }

  function hsInitSection(section) {
    if (section.dataset.hsInit === '1') return;
    section.dataset.hsInit = '1';

    var sticky = section.querySelector('.hs-sticky');
    var track = section.querySelector('.hs-track');
    if (!track || !sticky) return;

    var slides = track.querySelectorAll('.hs-slide');
    var videos = track.querySelectorAll('.hs-slide__video');
    if (!slides.length) return;

    var scrollDistance = 0;
    var headerOffset = 0;

    function getHeaderHeight() {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    }

    function setup() {
      headerOffset = getHeaderHeight();
      var lastSlide = slides[slides.length - 1];
      var viewportWidth = window.innerWidth;
      scrollDistance = Math.max(0, lastSlide.offsetLeft + lastSlide.offsetWidth - viewportWidth);

      if (scrollDistance <= 0) {
        section.style.height = '';
        return;
      }

      var stickyHeight = sticky.offsetHeight;
      section.style.height = stickyHeight + scrollDistance + headerOffset + 'px';
    }

    function update() {
      if (scrollDistance <= 0) {
        track.style.transform = 'translateX(0)';
        return;
      }

      var rect = section.getBoundingClientRect();
      /* Sticky pins when section.top reaches -headerOffset (because top: headerHeight) */
      var scrolled = -(rect.top + headerOffset);
      var progress = Math.max(0, Math.min(1, scrolled / scrollDistance));
      track.style.transform = 'translateX(' + -progress * scrollDistance + 'px)';
    }

    /* Video autoplay / pause via IntersectionObserver */
    if (videos.length) {
      var videoObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.play().catch(function () {});
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      videos.forEach(function (v) {
        videoObs.observe(v);
      });
    }

    /* Initial measure + paint */
    setup();
    update();

    /* Scroll → rAF‑throttled horizontal translation */
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    /* Recalc on resize (debounced) */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setup();
        update();
      }, 150);
    });
  }

  /* Boot */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hsInit);
  } else {
    hsInit();
  }

  /* Shopify theme‑editor hot‑reload */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.hs-section');
    if (s) {
      s.removeAttribute('data-hs-init');
      hsInitSection(s);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
